// Copyright (c) 2023 by Move Closer.

import { AbstractIntention, MappingTypes } from '@movecloser/front-core'

import {
  CompanyCreateInput,
  ShortCreateCompanyInput,
  UpdateCompanyInput
} from '../../../contexts/profile/contracts/company'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export class CompanyCreateIntention extends AbstractIntention<CompanyCreateInput> {
  protected map = {
    companyAdmin: {
      type: MappingTypes.Function,
      value: (item: CompanyCreateInput) => {
        return {
          email: item.companyAdmin.email,
          firstname: item.companyAdmin.firstName,
          lastname: item.companyAdmin.lastName
        }
      },
      target: 'company_admin'
    },
    email: 'company_email',
    name: 'company_name',
    legalAddress: {
      type: MappingTypes.Function,
      value: (item: CompanyCreateInput) => {
        const street = []
        for (const element of item.legalAddress.street) {
          street.push(element)
        }

        return {
          street,
          city: item.legalAddress.city,
          postcode: item.legalAddress.postCode,
          country_id: item.legalAddress.countryCode,
          telephone: item.legalAddress.telephone,
          region: {
            region: item.legalAddress.region.name,
            region_code: item.legalAddress.region.code,
            region_id: item.legalAddress.region.id
          }
        }
      },
      target: 'legal_address'
    },
    legalName: 'legal_name',
    vatTaxId: 'vat_tax_id'
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export class ShortCompanyCreateIntention extends AbstractIntention<ShortCreateCompanyInput> {
  protected map = {
    email: 'email',
    password: 'password',
    passwordConfirmation: 'password_confirmation',
    vatTaxId: 'vat_tax_id'
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export class CompanyUpdateIntention extends AbstractIntention<UpdateCompanyInput> {
  protected map = {
    companyEmail: 'company_email',
    companyName: 'company_name',
    legalAddress: {
      type: MappingTypes.Function,
      value: (item: CompanyCreateInput) => {
        const street = []
        for (const element of item.legalAddress.street) {
          street.push(element)
        }

        return {
          street,
          city: item.legalAddress.city,
          postcode: item.legalAddress.postCode,
          country_id: item.legalAddress.countryCode,
          telephone: item.legalAddress.telephone,
          region: {
            region: item.legalAddress.region.name,
            region_code: item.legalAddress.region.code,
            region_id: item.legalAddress.region.id
          }
        }
      },
      target: 'legal_address'
    },
    legalName: 'legal_name',
    vatTaxId: 'vat_tax_id'
  }
}
